import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  signal,
  NgZone,
  Input,
} from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { IS_SERVER } from '../../providers/is-platform.provider';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-countdown-timer',
  imports: [TranslocoDirective],
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  private readonly isServer = inject(IS_SERVER);
  private readonly ngZone = inject(NgZone);
  private targetDate!: Date;
  private subscription: Subscription | null = null;

  timeRemaining = signal({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  @Input({ required: true })
  set date(d: string) {
    this.targetDate = new Date(d);
  }

  ngOnInit(): void {
    if (this.isServer || !this.targetDate) {
      return;
    }

    this.startCountdown();
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  private startCountdown(): void {
    this.ngZone.runOutsideAngular(() => {
      this.updateTimeRemaining();
      this.subscription = interval(1000).subscribe(() => {
        this.updateTimeRemaining();
      });
    });
  }

  private stopCountdown(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateTimeRemaining(): void {
    const now = new Date();
    const difference = this.targetDate.getTime() - now.getTime();

    if (difference > 0) {
      const seconds = Math.floor(difference / 1000) % 60;
      const minutes = Math.floor(difference / (1000 * 60)) % 60;
      const hours = Math.floor(difference / (1000 * 60 * 60)) % 24;
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));

      this.timeRemaining.set({ days, hours, minutes, seconds });
    } else {
      this.timeRemaining.set({ days: 0, minutes: 0, hours: 0, seconds: 0 });
      this.stopCountdown();
    }
  }
}
